export class AsnDarkmodeService {
    /** darkmodeSetting holds the current appearance setting and can be used in other modules */
    private darkmodeSettings: 'light' | 'dark' = 'light';
    private listeners: Set<(mode: 'light' | 'dark') => void> = new Set();

    /**
     * Check `(prefers-color-scheme: dark` media query for automatic darkmode setting
     */
    public initializeAutomaticDarkmode() {
        const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');

        this.setDarkmode(mediaQuery.matches ? 'dark' : 'light');

        mediaQuery.addEventListener('change', (e) => {
            this.setDarkmode(e.matches ? 'dark' : 'light');
        });
    }

    /**
     * Set dark mode to `dark` or `light`.
     * Adds appropriate class to .ap wrappers on the page
     */
    public setDarkmode(setting: 'dark' | 'light') {
        if (document.readyState === 'loading') {
            window.addEventListener('DOMContentLoaded', () => this.addClass(setting), { once: true });
        } else {
            this.addClass(setting);
        }
    }

    /**
     * Get the current darkmode setting observable
     */
    public getDarkmodeSetting(): 'dark' | 'light' {
        return this.darkmodeSettings;
    }

    public subscribe(callback: (mode: 'dark' | 'light') => void): void {
        this.listeners.add(callback);
        callback(this.darkmodeSettings);
    }

    public unsubscribe(callback: (mode: 'dark' | 'light') => void): void {
        this.listeners.delete(callback);
    }

    private addClass(setting: 'dark' | 'light') {
        const containers = document.querySelectorAll('.ap'); // all

        const targetElements = containers.length > 0 ? Array.from(containers) : [document.body];
        targetElements.forEach((container) => {
            container.classList.remove('ap-light');
            container.classList.remove('ap-dark');
            container.classList.add(`ap-${setting}`);
        });

        this.darkmodeSettings = setting;
        this.listeners.forEach((cb) => cb(this.darkmodeSettings));
    }
}

export const asnDarkModeService = new AsnDarkmodeService();
